// reducers/groupModalReducer.js

const initialState = {
    paymentModalOpen: false,
};

const paymentModalReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_PAYMENT_MODAL_OPEN":
            return { ...state, paymentModalOpen: true };

        case "SET_PAYMENT_MODAL_CLOSE":
            return { ...state, paymentModalOpen: false };

        default:
            return state;
    }
};

export default paymentModalReducer;
